import { login } from "@/api/user";
import { getUserIdApiCompany } from "@/api/auth-login";
import { getToken, setToken, removeToken, getName, setName, removeName, getUserPhone, setUserPhone, removeUserPhone } from "@/utils/auth";
// import router, { resetRouter } from "@/router";

const state = {
    token: getToken(),
    name: getName(),
    userPhone: getUserPhone()
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_NAME: (state, name) => {
        state.name = name;
    },
    SET_USER_PHONE: (state, userPhone) => {
        state.userPhone = userPhone;
    }
};

const actions = {
    login({ commit }, userInfo) {
        const { username, password } = userInfo;
        return new Promise((resolve, reject) => {
            login({ username, password })
                .then((response) => {
                    const { data } = response;
                    if (data) {
                        let temp = data;
                        commit("SET_NAME", temp.username);
                        setName(temp.username);
                        commit("SET_TOKEN", temp.id);
                        setToken(temp.id);
                        commit("SET_USER_PHONE", temp.phone);
                        setUserPhone(temp.phone);
                    }
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    // 统一认证登录-个人
    authLoginPerson({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            try {
                // 从 sessionStorage 读取 token 和 userinfo
                const personToken = sessionStorage.getItem("personToken");
                const personUserInfoStr = sessionStorage.getItem("personUserInfo");
                
                if (!personToken || !personUserInfoStr) {
                    reject(new Error("未找到认证信息"));
                    return;
                }
                
                const personUserInfo = JSON.parse(personUserInfoStr);
                
                // 设置用户信息到 store
                if (personUserInfo.name) {
                    commit("SET_NAME", personUserInfo.name);
                    setName(personUserInfo.name);
                }
                
                // 使用 personToken 作为 token（或者使用 personUserInfo 中的 uid，根据实际需求）
                // 这里使用 personToken，如果需要使用 uid，可以改为 personUserInfo.uid
                commit("SET_TOKEN", personToken);
                setToken(personToken);
                
                if (personUserInfo.phone) {
                    commit("SET_USER_PHONE", personUserInfo.phone);
                    setUserPhone(personUserInfo.phone);
                }
                
                resolve({ id: personUserInfo.uid || personToken, ...personUserInfo });
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    // 统一认证登录-企业
    authLoginCompany({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            getUserIdApiCompany(userInfo)
                .then((response) => {
                    const { data } = response;
                    if (data) {
                        let temp = data;
                        commit("SET_NAME", temp.company);
                        setName(temp.company);
                        commit("SET_TOKEN", temp.id);
                        setToken(temp.id);
                        commit("SET_USER_PHONE", temp.comUscc);
                        setUserPhone(temp.comUscc);
                    }
                    resolve(data);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    },
    resetToken({ commit }) {
        return new Promise((resolve) => {
            commit("SET_TOKEN", "");
            commit("SET_NAME", "");
            commit("SET_USER_PHONE", "");
            removeToken();
            removeName();
            removeUserPhone();
            sessionStorage.removeItem("client-userInfo");
            sessionStorage.removeItem("accessToken");
            sessionStorage.removeItem("authType");
            sessionStorage.removeItem("Authorization");
            sessionStorage.removeItem("personToken");
            sessionStorage.removeItem("personUserInfo");
            localStorage.clear();
            sessionStorage.clear();
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
